// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/general/styles.scss
// module id = 18
// module chunks = 0